module.exports = __webpack_public_path__ + "img/adb28dd.png";